// To be determined a suitable threshold
// Exported for testing
export const MAX_STEPS_FROM_BASELINE = 10;
